import { Component, effect, inject, OnInit, ViewChild } from '@angular/core';
import { CommonModule, NgForOf } from '@angular/common';
import { HomePerformanceComponent } from '../../components/home-performance/home-performance.component';
import { HomeDisclaimerComponent } from '../../components/home-disclaimer/home-disclaimer.component';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule } from '@angular/forms';
import { ButtonDirective } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { PerformancefilterDto } from '../../models/dto/performancefilter-dto';
import { IndexIoService } from '../../services/index-io.service';
import { PerformancetableDto } from '../../models/dto/performancetable-dto';
import { ProgressSpinner } from 'primeng/progressspinner';
import { DocumentsDTO } from '../../models/dto/document-dto';

@Component({
  selector: 'bnpp-indx-home',
  imports: [
    NgForOf,
    HomePerformanceComponent,
    HomeDisclaimerComponent,
    DropdownModule,
    FormsModule,
    ButtonDirective,
    TabsModule,
    CommonModule,
    ProgressSpinner,
  ],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  standalone: true,
})
export class HomeComponent implements OnInit {
  private indexInfoService = inject(IndexIoService);
  public deployUrlHost = this.indexInfoService.getDeployUrlHost();
  @ViewChild(HomePerformanceComponent)
  homePerformanceComponent!: HomePerformanceComponent;
  indexPerformanceTableInfo = this.indexInfoService.indexPerformanceTable;
  documentsForHandBookAndIOSCOInfo =
    this.indexInfoService.documentsForHandBookAndIOSCOInfo;
  tab: 'cumulative' | 'calendar' = 'cumulative';
  filteredData: PerformancetableDto[] = [];
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  public resources: any[] = [
    {
      label: 'index handbook',
      url: this.deployUrlHost + '/Documents/Handbook',
    },
    {
      label: 'iosco statement',
      url: this.deployUrlHost + '/Documents/BnpIoscoUrl',
    },
  ];
  filter: PerformancefilterDto = {
    asset: '',
    productstyle: '',
    productType: '',
    geography: '',
    currency: '',
  };
  assets: string[] = [];
  productstyles: string[] = [];
  geographies: string[] = [];
  producttypes: string[] = [];
  currencies: string[] = [];
  performanceDataTotalRecords = 0;

  constructor() {
    effect(() => {
      const cumulativePerformanceData = this.indexPerformanceTableInfo();
      this.applyFilters(
        cumulativePerformanceData?.cumulativePerformanceDtoList as PerformancetableDto[],
        this.filter
      );
      this.initializeFilters();
    });
  }

  applyFilters(
    performanceData: PerformancetableDto[] | null,
    filters: PerformancefilterDto
  ) {
    if (!performanceData) return;

    this.performanceDataTotalRecords = performanceData.length;

    if (!filters) {
      this.filteredData = performanceData;
      return;
    }
    this.filteredData = performanceData.filter(
      (row) =>
        (!filters.asset || row.asset === filters.asset) &&
        (!filters.productstyle || row.secondLevel === filters.productstyle) &&
        (!filters.geography || row.geography === filters.geography) &&
        (!filters.productType || row.type === filters.productType) &&
        (!filters.currency || row.mdsCurrencyCode === filters.currency)
    );
  }

  private initializeFilters(): void {
    const filterResponse = this.indexPerformanceTableInfo()?.filterResponse;
    if (filterResponse) {
      this.assets = filterResponse.assets;
      this.assets.unshift("ALL");
      this.productstyles = filterResponse.productstyles;
      this.productstyles.unshift("ALL");
      this.geographies = filterResponse.geographies;
      this.geographies.unshift("ALL");
      this.producttypes = filterResponse.producttypes;
      this.producttypes.unshift("ALL");
      this.currencies = filterResponse.currencies;
      this.currencies.unshift("ALL");
    }
  }

  setFilters(filterkey?: string) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filterObj: any = this.filter;
    if(filterkey && filterObj[filterkey] === 'ALL') {
      filterObj[filterkey] = '';
    }
    this.applyFilters(
      this.indexPerformanceTableInfo()
        ?.cumulativePerformanceDtoList as PerformancetableDto[],
      filterObj
    );
  }

  exportExcel() {
    this.homePerformanceComponent.exportExcel();
  }

  resetFilter() {
    this.filter = {
      asset: '',
      productstyle: '',
      productType: '',
      geography: '',
      currency: '',
    };
    this.setFilters();
  }

  onDownloadDocument(item: DocumentsDTO) {
    this.indexInfoService
      .downloadDocument(
        'Document',
        item.Path,
        item.Title,
        item.FileExtension,
        item.S3Key
      )
      .subscribe();
  }

  ngOnInit(): void {
    const selectedResident = localStorage.getItem('selectedResident')!;
    this.indexInfoService.getPerformanceTableResults(selectedResident);
    this.indexInfoService.getDocumentsForHandBookAndIOSCO();
  }
}
